import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function Noroute() {
    const navigate = useNavigate()
    useEffect(() => {
        // navigate('/')
    }, [])

    return (
        <div className='w-full'>
            <div className="flex justify-center items-center h-screen w-[88%] mx-auto px-4">
                <div className="flex flex-col text-center ">
                    <p className='font-semibold text-xl text-[#4B4B4B] text-center mb-8'>404 - Page not found</p>
                    <img src="/assets/images/notfoundPage.svg" alt="NotFound" className="pb-6 w-" />
                    <p className=" text-base font-normal text-[#4B4B4B] mt-8 text-center">
                        Sorry, the page you’re looking for does not exist.
                        Click below to return to the previous page.
                    </p>
                    <button type='button'
                        onClick={()=>{navigate(-1)}}
                        className='bg-[#9E2064] px-4 py-2.5 w-full rounded-xl 
                        text-base text-white font-normal my-6 cursor-pointer'>
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    )
}
